/* Not Compliance · il comportamento delle pagine
   ---------------------------------------------------------------------------
   Porting di `site/assets/nc.js` dell'anteprima del 22/08, con una differenza
   sola ma grossa: qui il carrello e' vero. Nell'anteprima il cassetto era una
   scena disegnata, qui parla con `/cart/add.js` e si ridisegna da solo.

   Ogni blocco parte solo se il suo elemento esiste: non tutte le pagine hanno
   tutto, e il primo errore fermerebbe anche i successivi. */
(function () {
  'use strict';

  /* ---------------------------------------------------- comparse allo scorrimento */
  var rv = document.querySelectorAll('.rv');
  if (rv.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (v) {
      v.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('on'); io.unobserve(x.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('on'); }); }

  /* ---------------------------------------------------- menu da telefono */
  var bm = document.querySelector('[data-menu]'), nav = document.querySelector('.nav');
  if (bm && nav) bm.addEventListener('click', function () {
    var a = nav.classList.toggle('aperto');
    bm.setAttribute('aria-expanded', a ? 'true' : 'false');
  });

  /* ---------------------------------------------------- il cassetto, quello vero

     Si ridisegna chiedendo a Shopify la sola sezione del cassetto
     (`?section_id=nc-cassetto`) invece di ricaricare la pagina: e' il motivo
     per cui il cassetto e' una SEZIONE e non un frammento. Se un giorno
     tornasse frammento, quella chiamata risponderebbe con la pagina intera e
     il cassetto si riempirebbe di se stesso. */
  var radice = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function ilCassetto() { return document.getElementById('cassetto'); }

  function apri() {
    var cs = ilCassetto(); if (!cs) return;
    cs.hidden = false;
    document.body.classList.add('bloccato');
    requestAnimationFrame(function () { cs.classList.add('on'); });
  }

  function chiudi() {
    var cs = ilCassetto(); if (!cs) return;
    cs.classList.remove('on');
    document.body.classList.remove('bloccato');
    setTimeout(function () { cs.hidden = true; }, 300);
  }

  function ridisegna() {
    return fetch(radice + '?section_id=nc-cassetto', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var vecchio = ilCassetto(); if (!vecchio) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuovo = doc.getElementById('cassetto');
        if (!nuovo) return;
        var era = vecchio.classList.contains('on');
        vecchio.innerHTML = nuovo.innerHTML;
        vecchio.hidden = false;
        if (era) vecchio.classList.add('on');
        /* il contatore sull'icona sta fuori dal cassetto, va aggiornato a mano */
        var n = nuovo.getAttribute('data-articoli') || '0';
        document.querySelectorAll('[data-conta-carrello]').forEach(function (x) {
          x.textContent = n;
          x.hidden = n === '0';
        });
      });
  }

  /* i click si ascoltano sul documento: il contenuto del cassetto viene rifatto
     a ogni aggiunta, e i nodi di prima non esistono piu' */
  document.addEventListener('click', function (ev) {
    var chiude = ev.target.closest('[data-chiudi]');
    if (chiude) { ev.preventDefault(); chiudi(); return; }

    var apre = ev.target.closest('[data-apri-cassetto]');
    if (apre && ilCassetto()) { ev.preventDefault(); apri(); return; }

    var riga = ev.target.closest('[data-riga]');
    if (riga) {
      ev.preventDefault();
      cambia(riga.getAttribute('data-riga'), parseInt(riga.getAttribute('data-quantita'), 10));
      return;
    }

    var agg = ev.target.closest('[data-aggiungi]');
    if (agg) {
      ev.preventDefault();
      aggiungi([{ id: agg.getAttribute('data-aggiungi'), quantity: 1 }], agg);
    }
  });

  addEventListener('keydown', function (e) {
    var cs = ilCassetto();
    if (e.key === 'Escape' && cs && !cs.hidden) chiudi();
  });

  function cambia(riga, quantita) {
    fetch(radice + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(riga, 10), quantity: quantita })
    }).then(ridisegna);
  }

  function aggiungi(articoli, bottone) {
    var testo = bottone ? bottone.textContent : '';
    if (bottone) { bottone.disabled = true; bottone.textContent = 'Un attimo…'; }
    var finito = function () { if (bottone) { bottone.disabled = false; bottone.textContent = testo; } };
    return fetch(radice + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: articoli })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (esito) {
        finito();
        if (!esito.ok) {
          /* il messaggio di Shopify e' gia' in italiano e dice la cosa giusta
             (esaurito, quantita' non disponibile): non se ne inventa un altro */
          var box = document.querySelector('[data-errore-carrello]');
          if (box) { box.textContent = esito.d.description || esito.d.message || ''; box.hidden = false; }
          return false;
        }
        return ridisegna().then(function () { apri(); return true; });
      }).catch(function () { finito(); return false; });
  }

  /* ---------------------------------------------------- galleria della scheda
     Tre cose, e servono tutte e tre perche' le foto «scorrano»:

     1. le foto grandi si caricano in memoria appena la pagina ha finito. Prima
        il click chiedeva al CDN un jpg da 1200px e si aspettava: sembrava che
        la galleria fosse lenta, invece era la rete. Ora lo scambio e' istantaneo.
     2. si cambia src E srcset, o su una foto con srcset il click sembra non
        funzionare: il srcset batte il src, sempre.
     3. da telefono si scorre col dito. Prima si poteva solo bersagliare una
        miniatura da 62 pixel, ed e' il motivo per cui nessuno guardava la
        seconda foto. */
  var g = document.getElementById('pmain'), strip = document.getElementById('pstrip');
  if (g && strip) (function () {
    var bottoni = [].slice.call(strip.querySelectorAll('button'));
    if (!bottoni.length) return;
    var quadro = g.parentNode, attuale = 0;

    var grande = function (b) {
      var m = b.querySelector('img');
      return m ? (m.getAttribute('data-grande') || m.src) : '';
    };

    var vai = function (i) {
      if (i < 0) { i = bottoni.length - 1; }
      if (i >= bottoni.length) { i = 0; }
      var url = grande(bottoni[i]);
      if (!url || i === attuale) { return; }
      attuale = i;
      bottoni.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      try { bottoni[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}

      var fatto = false;
      var mostra = function () {
        if (fatto) { return; }
        fatto = true;
        g.removeAttribute('srcset'); g.removeAttribute('sizes');
        g.src = url;
        requestAnimationFrame(function () { g.classList.remove('cambia'); });
      };
      g.classList.add('cambia');
      var pre = new Image();
      pre.onload = mostra; pre.onerror = mostra;
      pre.src = url;
      if (pre.complete) { mostra(); }
      /* se il CDN non risponde, la foto non resta sbiadita per sempre */
      setTimeout(mostra, 700);
    };

    strip.addEventListener('click', function (ev) {
      var b = ev.target.closest('button');
      if (b) { vai(bottoni.indexOf(b)); }
    });

    /* lo scorrimento col dito sulla foto grande */
    var partenza = null, verticale = null;
    quadro.addEventListener('touchstart', function (ev) {
      partenza = ev.touches[0].clientX; verticale = ev.touches[0].clientY;
    }, { passive: true });
    quadro.addEventListener('touchend', function (ev) {
      if (partenza === null) { return; }
      var dx = ev.changedTouches[0].clientX - partenza;
      var dy = ev.changedTouches[0].clientY - verticale;
      partenza = null;
      /* solo se il dito e' andato di lato davvero: se no ogni scroll della
         pagina cambierebbe foto */
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) { return; }
      vai(attuale + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* e con le frecce, quando il fuoco e' sulle miniature */
    strip.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { vai(attuale + 1); }
      else if (ev.key === 'ArrowLeft') { vai(attuale - 1); }
      else { return; }
      ev.preventDefault();
      bottoni[attuale].focus();
    });

    var scalda = function () {
      bottoni.forEach(function (b) {
        var url = grande(b);
        if (url) { var p = new Image(); p.src = url; }
      });
    };
    if (document.readyState === 'complete') { scalda(); }
    else { window.addEventListener('load', scalda); }
  })();

  /* ---------------------------------------------------- le due offerte
     Il totale segue quella scelta, e il bottone cambia cosa aggiunge: una
     fragranza sola, oppure le tre della sua collezione. */
  var offerte = document.querySelector('[data-offerte]');
  var comprare = document.querySelectorAll('[data-compra]');
  if (offerte) {
    var tot = document.querySelector('[data-totale]');
    var ris = document.querySelector('[data-ris]');
    var soldi = function (centesimi) { return '€ ' + (centesimi / 100).toFixed(2).replace('.', ','); };

    var aggiorna = function () {
      var s = offerte.querySelector('input[name="offerta"]:checked'); if (!s) return;
      var prezzo = parseInt(s.getAttribute('data-prezzo'), 10) || 0;
      var pieno = parseInt(s.getAttribute('data-pieno'), 10) || 0;
      if (tot) tot.textContent = soldi(prezzo);
      if (ris) {
        var r = pieno - prezzo;
        ris.hidden = r <= 0;
        if (r > 0) ris.textContent = 'Risparmi ' + soldi(r);
      }
      comprare.forEach(function (b) { b.setAttribute('data-varianti', s.getAttribute('data-varianti') || ''); });
    };
    offerte.querySelectorAll('input[name="offerta"]').forEach(function (i) {
      i.addEventListener('change', aggiorna);
    });
    aggiorna();
  }

  /* il bottone di acquisto: manda al carrello le varianti dell'offerta scelta */
  comprare.forEach(function (b) {
    b.addEventListener('click', function (ev) {
      ev.preventDefault();
      var v = (b.getAttribute('data-varianti') || '').split(',').filter(Boolean);
      if (!v.length) return;
      var articoli = v.map(function (x) { return { id: x, quantity: 1 }; });
      aggiungi(articoli, b).then(function (andata) {
        if (andata && b.hasAttribute('data-subito')) location.href = radice + 'checkout';
      });
    });
  });

  /* ---------------------------------------------------- puntini delle recensioni */
  var recs = document.querySelector('.recs'), punti = document.querySelector('.punti');
  if (recs && punti) recs.addEventListener('scroll', function () {
    var i = Math.round(recs.scrollLeft / (recs.scrollWidth / recs.children.length));
    var n = punti.children.length;
    [].forEach.call(punti.children, function (p, k) {
      p.classList.toggle('on', k === Math.min(n - 1, Math.floor(i * n / recs.children.length)));
    });
  }, { passive: true });
})();
